<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Criar mensalidade
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12" v-if="isFromParcelamento() && !isContinuous()">
              <z-alert
                class="parcelamento-warning"
                variant="warning"
                title="Atenção"
                :description="finalValue()"
              />
            </div>
            <div class="col-md-6">
              <money-field
                label="Valor"
                v-model="billForm.get('amountWithDiscount').value"
                :errors="billForm.get('amountWithDiscount').errors"
                @input="billForm.get('amountWithDiscount').validateField()"
              />
            </div>
            <div class="col-md-6">
              <date-field
                label="Data de Vencimento"
                v-model="billForm.get('dueDate').value"
                :errors="billForm.get('dueDate').errors"
                @input="billForm.get('dueDate').validateField()"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Aplicar juros e multa"
                v-model="billForm.get('applyCharges').value"
                :errors="billForm.get('applyCharges').errors"
                :options="applyChargesOptions"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="ID Externo"
                v-model="billForm.get('externalId').value"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <textarea-field
                label="Motivo da Criação"
                v-model="billForm.get('observations').value"
                :errors="billForm.get('observations').errors"
                @input="billForm.get('observations').validateField()"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
          <button class="btn btn-primary" @click="createBill">
            Criar mensalidade
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { FormGroup } from 'utils/form';
import {
  DateField, InputField, MoneyField, SelectField, TextareaField,
} from 'components/form';
import moment from 'moment';
import BillsService from 'services/BillsService';
import 'moment/locale/pt-br';
import Permissions from 'mixins/Permissions';

export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      billForm: new FormGroup({
        amountWithDiscount: {
          greaterThanOrEqualTo: 0,
          lowerThan: 100,
          required: true,
        },
        observations: {
          required: true,
        },
        dueDate: {
          required: true,
          date: true,
        },
        applyCharges: {
          value: true,
          required: true,
          boolean: true,
        },
        externalId: {},
        contractId: '',
      }),
      applyChargesOptions: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
    };
  },
  mixins: [Permissions],
  components: {
    DateField,
    InputField,
    MoneyField,
    SelectField,
    TextareaField,
  },
  created() {
    this.billForm.addValues({
      dueDate: this.tomorrowDate(),
      amountWithDiscount: parseFloat(this.contract.student_value),
      contractId: this.contract.id,
    });

    this.billForm.get('amountWithDiscount').lowerThan = parseFloat(this.contract.full_value);
    this.billForm.get('observations').validateField();
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    tomorrowDate() {
      return moment().add(1, 'days').format('DD/MM/YYYY');
    },

    isFromParcelamento() {
      return this.billing.origin === 'from_parcelamento';
    },

    isContinuous() {
      return this.billing.discharge_type === 'continuous';
    },

    finalValue() {
      const inputValue = this.billForm.getRawValue().amount_with_discount;
      const discharge = this.billing.discharge_percentual;
      const finalValue = inputValue * (discharge / 100);
      return `Desconto de parcelamento: ${discharge}%.\n Valor final da mensalidade R$ ${finalValue}`;
    },
    createBill() {
      const hasFreeBillCreationPermission = this.userPermissions.bill.includes('free_bill_creation');
      const billValue = this.billForm.get('amountWithDiscount').value;
      const freeBillNotPermited = !hasFreeBillCreationPermission && billValue === 0;

      if (freeBillNotPermited) {
        this.$alert.notifyAlert('Você não tem permissão para criar mensalidades nulas');
        return;
      }
      if (!this.billForm.validateForm()) {
        return;
      }

      BillsService.createBill(this.billForm.getRawValue())
        .then(() => {
          this.loadStudentBills();
          this.$alert.notifySuccess('Mensalidade criada');
          this.$emit('close');
        })
        .catch((error) => {
          this.inputError = `Erro ao criar mensalidade: ${error.message}`;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style>
  .parcelamento-warning {
    margin-bottom: 5px;
  }
</style>
